import React from "react";
import { Status } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const UnreachableStatus = (props) => {
  const { size } = props;

  return <Status data-testid="unReachableStatus" state="unknown" size={size} />;
};

UnreachableStatus.propTypes = {
  size: PropTypes.string,
};

UnreachableStatus.defaultProps = {
  size: "larger",
};

export default UnreachableStatus;
